// Translation file version for cache busting
const TRANSLATION_VERSION = '2024-11-08-v2';
console.log('📦 [fa.ts] Loading translation file - Version:', TRANSLATION_VERSION);

export default {
  // General
  appName: 'پورتال مدیریت',
  login: 'ورود',
  logout: 'خروج',
  email: 'ایمیل',
  password: 'رمز عبور',
  forgotPassword: 'رمز عبور را فراموش کرده‌اید؟',
  rememberMe: 'مرا به خاطر بسپار',
  welcome: 'خوش آمدید',
  welcomeMessage: 'برای ادامه به پورتال مدیریت وارد شوید',
  profile: 'پروفایل',
  help: 'راهنما',
  close: 'بستن',
  retry: 'تلاش مجدد',
  pleaseTryAgain: 'لطفاً دوباره تلاش کنید',
  errorLoadingData: 'دریافت اطلاعات با مشکل مواجه شد',
  noDataAvailable: 'داده‌ای یافت نشد',
  technicalIssue: 'مشکل فنی رخ داده است',
  networkError: 'اتصال به اینترنت قطع شده است. لطفاً اتصال خود را بررسی کنید.',
  authExpired: 'نشست شما منقضی شده است. لطفاً دوباره وارد شوید.',
  serverError: 'خطای سرور. لطفاً بعداً دوباره تلاش کنید.',
  prayerNotFound: 'دعا یافت نشد.',
  backToList: 'بازگشت به لیست',
  
  // Error Boundary
  systemError: 'خطای سیستم',
  networkErrorChip: 'خطای شبکه',
  somethingWentWrong: 'مشکلی پیش آمده است',
  connectionFailed: 'اتصال به سرور برقرار نشد',
  unexpectedError: 'برنامه با خطای غیرمنتظره‌ای مواجه شد. لطفاً صفحه را بارگذاری مجدد کنید',
  checkInternetConnection: 'لطفاً اتصال اینترنت خود را بررسی کنید و دوباره تلاش کنید',
  reloadPage: 'بارگذاری مجدد',
  tryAgain: 'تلاش مجدد',
  home: 'خانه',
  technicalDetails: 'جزئیات فنی',
  
  // User Profile
  userDetails: 'جزئیات کاربر',
  viewAndManageYourProfile: 'مشاهده و مدیریت اطلاعات پروفایل خود',
  editProfile: 'ویرایش پروفایل',
  contactInformation: 'اطلاعات تماس',
  accountInformation: 'اطلاعات حساب کاربری',
  phone: 'تلفن',
  bio: 'بیوگرافی',
  userId: 'شناسه کاربر',
  accountCreated: 'تاریخ ایجاد حساب',
  lastLogin: 'آخرین ورود',
  memberSince: 'عضویت از',
  errorLoadingProfile: 'خطا در بارگذاری پروفایل. لطفاً دوباره تلاش کنید.',
  never: 'هرگز',
  invalidDate: 'تاریخ نامعتبر',
  
  // User Roles
  superuser: 'سوپر ادمین',
  admin: 'مدیر',
  editor: 'ویرایشگر',
  viewer: 'بیننده',
  user: 'کاربر',
  
  // User Actions
  confirmDelete: 'آیا مطمئن هستید که می‌خواهید حذف کنید',
  userDeletedSuccessfully: 'کاربر با موفقیت حذف شد',
  errorDeletingUser: 'خطا در حذف کاربر',
  errorTogglingStatus: 'خطا در تغییر وضعیت کاربر',
  userCreatedSuccessfully: 'کاربر با موفقیت ایجاد شد',
  errorCreatingUser: 'خطا در ایجاد کاربر',
  passwordsDoNotMatch: 'رمزهای عبور مطابقت ندارند',
  passwordMinLength: 'رمز عبور باید حداقل 8 کاراکتر باشد',
  usernameIsRequired: 'نام کاربری الزامی است',
  firstName: 'نام',
  lastName: 'نام خانوادگی',
  enterFirstName: 'نام را وارد کنید',
  enterLastName: 'نام خانوادگی را وارد کنید',
  viewUserProfileDetails: 'مشاهده پروفایل و جزئیات کاربر',
  updateUserInformation: 'به‌روزرسانی اطلاعات کاربر',
  enterName: 'نام را وارد کنید',
  enterUsername: 'نام کاربری را وارد کنید',
  selectRole: 'نقش را انتخاب کنید',
  roleAutoCalculated: 'نقش کاربر به صورت خودکار بر اساس گروه‌های دسترسی محاسبه می‌شود (superuser ← admin ← user)',
  addNewUserToSystem: 'افزودن کاربر جدید به سیستم',
  confirmYourPassword: 'تأیید رمز عبور',
  enterPassword: 'رمز عبور را وارد کنید',
  newPassword: 'رمز عبور جدید',
  enterNewPassword: 'رمز عبور جدید را وارد کنید',
  passwordsRequired: 'فیلدهای رمز عبور الزامی هستند',
  passwordResetSuccessfully: 'رمز عبور با موفقیت تغییر کرد',
  errorResettingPassword: 'خطا در تغییر رمز عبور',
  userUpdatedSuccessfully: 'کاربر با موفقیت به‌روزرسانی شد',
  errorUpdatingUser: 'خطا در به‌روزرسانی کاربر',
  backToUsers: 'بازگشت به کاربران',
  userNotFound: 'کاربر یافت نشد',
  permissionsUpdatedSuccessfully: 'دسترسی‌ها با موفقیت به‌روزرسانی شدند',
  errorUpdatingPermissions: 'خطا در به‌روزرسانی دسترسی‌ها',
  usernameAutoGeneratedFromEmail: 'اگر خالی باشد، نام کاربری از ایمیل ساخته می‌شود',
  
  // Sidebar Menu
  dashboard: 'داشبورد',
  users: 'کاربران و دسترسی‌ها',
  technicalSupport: 'پشتیبانی فنی',
  settings: 'تنظیمات کلی پورتال',
  generalSettings: 'عمومی',
  languages: 'زبان‌ها',
  statistics: 'آمار',
  management: 'مدیریت',
  
  // Languages
  code: 'کد',
  languagesTable: 'جدول زبان‌ها',
  noLanguagesFound: 'زبانی یافت نشد',
  searchLanguages: 'جستجو در کد یا نام زبان',
  activateLanguage: 'فعال‌سازی زبان',
  deactivateLanguage: 'غیرفعال‌سازی زبان',
  confirmActivateLanguage: 'آیا مطمئن هستید که می‌خواهید {{name}} را فعال کنید؟',
  confirmDeactivateLanguage: 'آیا مطمئن هستید که می‌خواهید {{name}} را غیرفعال کنید؟',
  activate: 'فعال‌سازی',
  deactivate: 'غیرفعال‌سازی',
  all: 'همه',
  active: 'فعال',
  inactive: 'غیرفعال',
  status: 'وضعیت',
  
  // Portal Sections
  portalSections: 'بخش‌های پورتال',
  imamIntro: 'زندگینامه امام',
  hadiths: 'احادیث',
  specialFiles: 'فایل‌های ویژه',
  prayers: 'ادعیه و زیارات',

  // Special Files
  createSpecialFile: 'ایجاد فایل ویژه',
  editSpecialFile: 'ویرایش فایل ویژه',
  createSpecialFileDescription: 'ایجاد یک فایل ویژه جدید با محتوای سفارشی',
  editSpecialFileDescription: 'ویرایش اطلاعات و محتوای فایل ویژه',
  addSpecialFile: 'افزودن فایل ویژه',
  specialFilesTable: 'جدول فایل‌های ویژه',
  noSpecialFilesFound: 'فایل ویژه‌ای یافت نشد',
  itemsSelected: 'مورد انتخاب شده',
  selectedItems: 'موارد انتخاب شده',
  availableItems: 'موارد موجود',
  noItemsFound: 'موردی یافت نشد',
  noItemsAvailable: 'موردی موجود نیست',
  searchBooks: 'جستجوی کتاب‌ها...',
  searchMedia: 'جستجوی رسانه‌ها...',
  searchArticles: 'جستجوی مقالات...',
  noBooksAvailable: 'کتابی موجود نیست',
  noMediaAvailable: 'رسانه‌ای موجود نیست',
  noArticlesAvailable: 'مقاله‌ای موجود نیست',
  sectionTitle: 'عنوان بخش',
  sectionDescription: 'توضیحات بخش',
  enterBookSectionTitle: 'مثال: کتاب‌های مرتبط',
  enterBookSectionDescription: 'توضیحات بخش کتاب‌ها را وارد کنید',
  enterMultimediaSectionTitle: 'مثال: ویدئوها و تصاویر',
  enterMultimediaSectionDescription: 'توضیحات بخش چندرسانه‌ای را وارد کنید',
  enterArticleSectionTitle: 'مثال: مقالات مرتبط',
  enterArticleSectionDescription: 'توضیحات بخش مقالات را وارد کنید',
  selectedBooks: 'کتاب‌های انتخاب شده',
  selectedMedia: 'رسانه‌های انتخاب شده',
  selectedArticles: 'مقالات انتخاب شده',
  selectBooks: 'انتخاب کتاب‌ها',
  selectMedia: 'انتخاب رسانه‌ها',
  selectArticles: 'انتخاب مقالات',
  booksSection: 'بخش کتاب‌ها',
  multimediaSection: 'بخش چندرسانه‌ای',
  articlesSection: 'بخش مقالات',
  noTopicsAdded: 'هیچ موضوعی اضافه نشده است',
  confirm: 'تأیید',
  image: 'تصویر',
  bookSectionTitle: 'عنوان بخش کتاب',
  bookSectionDescription: 'توضیحات بخش کتاب',
  multimediaSectionTitle: 'عنوان بخش چندرسانه‌ای',
  multimediaSectionDescription: 'توضیحات بخش چندرسانه‌ای',
  articleSectionTitle: 'عنوان بخش مقاله',
  articleSectionDescription: 'توضیحات بخش مقاله',
  multimediaItems: 'موارد چندرسانه‌ای',
  media: 'رسانه',
  published: 'منتشر شده',
  unpublished: 'منتشر نشده',
  draft: 'پیش‌نویس',

  // Prayer Sub-sections
  prayerCategories: 'دسته‌بندی‌های ادعیه',
  loadingCategories: 'بارگذاری دسته‌بندی‌ها...',
  selected: 'انتخاب شده',
  selectedCategories: 'دسته‌بندی‌های انتخاب شده',
  addCategory: 'افزودن دسته‌بندی',
  viewCategoryPrayers: 'مشاهده دعاهای این دسته‌بندی',
  clickToViewPrayers: 'کلیک برای مشاهده',
  fromSubcategories: 'از زیرمجموعه‌ها',
  categoryCreatedSuccessfully: 'دسته‌بندی با موفقیت ایجاد شد',
  categoryUpdatedSuccessfully: 'دسته‌بندی با موفقیت به‌روزرسانی شد',
  categoryDeletedSuccessfully: 'دسته‌بندی با موفقیت حذف شد',
  categoryOrderUpdatedSuccessfully: 'ترتیب دسته‌بندی‌ها با موفقیت به‌روزرسانی شد',
  errorCreatingCategory: 'خطا در ایجاد دسته‌بندی',
  errorUpdatingCategory: 'خطا در به‌روزرسانی دسته‌بندی',
  errorDeletingCategory: 'خطا در حذف دسته‌بندی',
  errorUpdatingCategoryOrder: 'خطا در به‌روزرسانی ترتیب دسته‌بندی‌ها',
  prayerCreatedSuccessfully: 'دعا با موفقیت ایجاد شد',
  prayerUpdatedSuccessfully: 'دعا با موفقیت به‌روزرسانی شد',
  prayerDeletedSuccessfully: 'دعا با موفقیت حذف شد',
  errorCreatingPrayer: 'خطا در ایجاد دعا',
  errorUpdatingPrayer: 'خطا در به‌روزرسانی دعا',
  errorDeletingPrayer: 'خطا در حذف دعا',
  showing: 'نمایش',
  of: 'از',
  audio: 'صدا',
  withAudio: 'دارای صدا',
  withoutAudio: 'بدون صدا',
  available: 'موجود',
  notAvailable: 'موجود نیست',
  updatedAt: 'تاریخ بروزرسانی',
  prayerReciters: 'قاریان ادعیه',
  prayerReferences: 'منابع ادعیه',
  prayerParts: 'قسمت‌های ادعیه',

  // Prayer Actions
  addPrayer: 'افزودن دعا',
  addPrayerPart: 'افزودن قسمت دعا',
  addReciter: 'افزودن قاری',
  addReference: 'افزودن منبع',

  // Prayer Fields
  prayer: 'دعا',
  prayerPart: 'قسمت دعا',
  reciter: 'قاری',
  reciters: 'قاریان',
  reference: 'منبع',
  text: 'متن',
  partIndex: 'شماره قسمت',
  translations: 'ترجمه‌ها',
  partText: 'متن قسمت',
  partTranslations: 'ترجمه‌های قسمت',
  localAlpha: 'الفبای محلی',
  filterFields: 'فیلتر فیلدهای قابل مشاهده',
  selectFieldsToDisplay: 'فیلدهایی که می‌خواهید در قسمت‌های دعا نمایش داده شود را انتخاب کنید:',
  fieldsActive: 'فیلد فعال',

  // Prayer Tables
  prayersTable: 'جدول دعاها',
  prayerPartsTable: 'جدول قسمت‌های دعا',
  prayerRecitersTable: 'جدول قاریان دعا',
  prayerReferencesTable: 'جدول منابع دعا',
  prayerCategoriesTable: 'جدول دسته‌بندی‌های دعا',

  // Prayer Status
  noPrayersFound: 'دعایی یافت نشد',
  noPrayerPartsFound: 'قسمتی از دعا یافت نشد',
  noPrayerRecitersFound: 'قاری دعایی یافت نشد',
  noPrayerReferencesFound: 'منبع دعایی یافت نشد',
  noPrayerCategoriesFound: 'دسته‌بندی دعایی یافت نشد',

  // Prayer Common
  noText: 'بدون متن',
  noDescription: 'بدون توضیحات',
  noName: 'بدون نام',
  rootCategory: 'دسته‌بندی اصلی',
  part: 'قسمت',

  // Prayer Edit Pages
  editPrayer: 'ویرایش دعا',
  editPrayerPart: 'ویرایش قسمت دعا',
  editPrayerCategory: 'ویرایش دسته‌بندی دعا',
  addPrayerReciter: 'افزودن قاری دعا',
  createNewPrayerReciter: 'ایجاد قاری دعا جدید',
  editPrayerReciter: 'ویرایش قاری دعا',
  pleaseEnterReciterName: 'لطفا نام قاری را وارد کنید',
  editPrayerReference: 'ویرایش منبع دعا',
  deletePrayer: 'حذف دعا',
  
  // Prayer Detail Page
  prayerDetails: 'جزئیات دعا',
  errorLoadingPrayer: 'خطا در بارگذاری دعا',
  prayerNotFound: 'دعا یافت نشد',
  backToList: 'بازگشت به لیست',
  audioAvailable: 'صوت موجود است',
  audioNotSupported: 'مرورگر شما از پخش صوت پشتیبانی نمی‌کند',
  noTranslations: 'ترجمه‌ای موجود نیست',

  // Prayer Edit Descriptions
  updatePrayerInformation: 'به‌روزرسانی اطلاعات و ترجمه‌های دعا',
  updatePrayerPartInformation: 'به‌روزرسانی اطلاعات قسمت دعا',
  updatePrayerCategoryInformation: 'به‌روزرسانی اطلاعات دسته‌بندی دعا',
  updatePrayerReciterInformation: 'به‌روزرسانی اطلاعات قاری دعا',
  updatePrayerReferenceInformation: 'به‌روزرسانی اطلاعات منبع دعا',

  // Prayer Edit Fields
  prayerBasicDetails: 'جزئیات اصلی دعا',
  selectPrayerCategories: 'انتخاب دسته‌بندی‌های دعا',
  prayerAudioFile: 'فایل صوتی دعا',
  managePrayerParts: 'مدیریت قسمت‌های دعا',
  selectPrayer: 'انتخاب دعا',
  selectParentCategory: 'انتخاب دسته‌بندی والد',
  categoryOrderDescription: 'ترتیب نمایش دسته‌بندی',
  parentCategory: 'دسته‌بندی والد',
  parentCategoryOptional: 'برای ساخت دسته‌بندی ریشه خالی بگذارید',
  cannotSetSelfAsParent: 'نمی‌توان دسته‌بندی را به عنوان والد خود تنظیم کرد',
  startTypingToSearch: 'برای جستجو تایپ کنید',
  reciterName: 'نام قاری',
  enterReciterName: 'نام قاری را وارد کنید',
  autoGeneratedFromName: 'از نام به صورت خودکار تولید می‌شود',
  reciterTranslations: 'ترجمه‌های قاری',
  avatarDescription: 'مسیر تصویر نمایه قاری',
  referenceTitle: 'عنوان منبع',
  enterReferenceTitle: 'عنوان منبع را وارد کنید',
  enterThumbnailPath: 'مسیر تصویر کوچک را وارد کنید',
  thumbnailDescription: 'تصویر کوچکی که در لیست نمایش داده می‌شود',
  descriptionTranslations: 'ترجمه‌های توضیحات',
  avatarPreview: 'پیش‌نمایش تصویر نمایه',
  uploadAvatar: 'آپلود آواتار',
  avatarWillBeDisplayed: 'این تصویر در لیست قاریان نمایش داده خواهد شد',
  thumbnailPreview: 'پیش‌نمایش تصویر کوچک',
  thumbnailWillBeDisplayed: 'این تصویر در لیست منابع نمایش داده خواهد شد',

  // Prayer Edit Actions
  makePrayerVisible: 'دعا را قابل مشاهده کنید',
  makePrayerPartVisible: 'قسمت دعا را قابل مشاهده کنید',
  makeCategoryVisible: 'دسته‌بندی را قابل مشاهده کنید',
  priorityDescription: 'اولویت نمایش در لیست‌ها',

  // Special Files Actions
  addSpecialFile: 'افزودن فایل ویژه',
  editSpecialFile: 'ویرایش فایل ویژه',

  // Special Files Fields
  specialFile: 'فایل ویژه',
  specialFilesTable: 'جدول فایل‌های ویژه',
  searchSpecialFiles: 'جستجوی فایل‌های ویژه',
  multimediaItems: 'آیتم‌های چندرسانه‌ای',
  multimedia: 'چندرسانه‌ای',
  articles: 'مقاله‌ها',
  topics: 'موضوعات',
  media: 'رسانه',
  basicInformation: 'اطلاعات پایه',
  mediaFiles: 'فایل‌های رسانه',
  colorSettings: 'تنظیمات رنگ',
  contentSections: 'بخش‌های محتوا',
  booksSection: 'بخش کتاب‌ها',
  multimediaSection: 'بخش چندرسانه‌ای',
  articlesSection: 'بخش مقاله‌ها',

  // Special Files Form Fields
  bookSectionTitle: 'عنوان بخش کتاب‌ها',
  bookSectionDescription: 'توضیحات بخش کتاب‌ها',
  multimediaSectionTitle: 'عنوان بخش چندرسانه‌ای',
  multimediaSectionDescription: 'توضیحات بخش چندرسانه‌ای',
  articleSectionTitle: 'عنوان بخش مقاله‌ها',
  articleSectionDescription: 'توضیحات بخش مقاله‌ها',
  addTopic: 'افزودن موضوع',
  topicTitle: 'عنوان موضوع',
  topicDescription: 'توضیحات موضوع',
  enterTopicTitle: 'عنوان موضوع را وارد کنید',
  enterTopicDescription: 'توضیحات موضوع را وارد کنید',
  topicTitleRequired: 'عنوان موضوع الزامی است',
  primaryColor: 'رنگ اصلی',
  secondaryColor: 'رنگ ثانویه',
  accentColor: 'رنگ برجسته',
  backgroundColor: 'رنگ پس‌زمینه',
  thumbnail: 'تصویر بند انگشتی',
  backgroundImage: 'تصویر پس‌زمینه',
  video: 'ویدیو',
  videoThumbnail: 'تصویر بند انگشتی ویدیو',
  specialFileThumbnailDescription: 'تصویر اصلی بند انگشتی برای فایل ویژه',
  backgroundImageDescription: 'تصویر پس‌زمینه برای فایل ویژه',
  videoDescription: 'محتوای ویدیو برای فایل ویژه',
  videoThumbnailDescription: 'تصویر بند انگشتی/پوستر برای ویدیو',
  specialFileSlugDescription: 'نامک URL تولید شده به صورت خودکار',
  specialFileOrderDescription: 'ترتیب برای مرتب‌سازی فایل‌های ویژه',
  enterBookSectionTitle: 'عنوان بخش کتاب‌ها را وارد کنید',
  enterBookSectionDescription: 'توضیحات بخش کتاب‌ها را وارد کنید',
  enterMultimediaSectionTitle: 'عنوان بخش چندرسانه‌ای را وارد کنید',
  enterMultimediaSectionDescription: 'توضیحات بخش چندرسانه‌ای را وارد کنید',
  enterArticleSectionTitle: 'عنوان بخش مقاله‌ها را وارد کنید',
  enterArticleSectionDescription: 'توضیحات بخش مقاله‌ها را وارد کنید',

  // Special Files Status
  noSpecialFilesFound: 'فایل ویژه‌ای یافت نشد',

  // Special Files Edit
  updateSpecialFileInformation: 'به‌روزرسانی اطلاعات فایل ویژه',

  // News
  newsCategories: 'دسته‌بندی‌های اخبار',

  // News Actions
  addNews: 'افزودن خبر',
  editNews: 'ویرایش خبر',
  createNews: 'ایجاد خبر',
  newsDetail: 'جزئیات خبر',
  viewNewsInformation: 'مشاهده اطلاعات و جزئیات خبر',
  createNewNewsArticle: 'ایجاد مطلب خبری جدید',

  // News Fields
  news: 'خبر',
  summary: 'خلاصه',
  publishDate: 'تاریخ انتشار',
  newsTable: 'جدول اخبار',
  newsBasicDetails: 'جزئیات اصلی خبر',
  newsFullContent: 'محتوای کامل خبر',
  publishing: 'انتشار',
  publishingSettings: 'تنظیمات انتشار',
  featured: 'ویژه',
  suggested: 'پیشنهاد شده',
  regular: 'معمولی',
  markAsSuggested: 'علامت‌گذاری به عنوان خبر ویژه',
  newsActiveDescription: 'این خبر برای کاربران قابل مشاهده باشد',

  // News Edit
  updateNewsInformation: 'به‌روزرسانی اطلاعات و محتوای خبر',
  enterNewsTitle: 'عنوان خبر را وارد کنید',
  enterNewsSummary: 'خلاصه خبر را وارد کنید',
  enterNewsContent: 'محتوای خبر را وارد کنید',
  summaryDescription: 'توضیح مختصر خبر برای نمایش در لیست‌ها',
  generatingContent: 'در حال تولید محتوای بهبود یافته',
  clickToUpload: 'برای آپلود کلیک کنید',
  maxSize5MB: 'حداکثر حجم: ۵ مگابایت',
  pleaseSelectImage: 'لطفا یک فایل تصویری انتخاب کنید',
  imageTooLarge: 'حجم تصویر باید کمتر از ۵ مگابایت باشد',
  uploadFailed: 'آپلود تصویر ناموفق بود',
  titleRequired: 'عنوان الزامی است',
  summaryRequired: 'خلاصه الزامی است',
  languageRequired: 'لطفا یک زبان انتخاب کنید',
  saveFailed: 'ذخیره خبر ناموفق بود',
  newsNotFound: 'خبر یافت نشد',
  fullContentOfNews: 'محتوای کامل خبر',
  autoGeneratedFromTitle: 'تولید خودکار از عنوان',
  slugDescription: 'نسخه URL-friendly از عنوان',

  // News Status
  noNewsFound: 'خبری یافت نشد',
  noNewsCategoriesFound: 'دسته‌بندی خبری یافت نشد',

  // News Preview
  preview: 'پیش‌نمایش',

  // Wiki Sub-sections
  wikiEntries: 'مقاله‌های ویکی',
  wikiCategories: 'دسته‌بندی‌های ویکی',
  wikiAuthors: 'نویسندگان ویکی',
  wikiContents: 'محتوای ویکی',

  // Wiki Actions
  addWikiEntry: 'افزودن مقاله ویکی',
  addWikiCategory: 'افزودن دسته‌بندی ویکی',
  addAuthor: 'افزودن نویسنده',

  // Wiki Fields
  wikiEntry: 'مقاله ویکی',
  author: 'نویسنده',
  biography: 'زندگی‌نامه',
  content: 'محتوا',
  unknownAuthor: 'نویسنده نامشخص',

  // Wiki Tables
  wikiTable: 'جدول مقالات ویکی',
  wikiCategoriesTable: 'جدول دسته‌بندی‌های ویکی',
  authorsTable: 'جدول نویسندگان',
  wikiContentsTable: 'جدول محتوای ویکی',

  // Wiki Status
  noWikiFound: 'مقاله‌ای یافت نشد',
  noCategoriesFound: 'دسته‌بندی یافت نشد',
  noCategories: 'دسته‌بندی موجود نیست',
  noAuthorsFound: 'نویسنده‌ای یافت نشد',
  noWikiContentsFound: 'محتوایی یافت نشد',

  // Wiki Edit Pages
  editWikiEntry: 'ویرایش مقاله ویکی',
  editCategory: 'ویرایش دسته‌بندی',
  editAuthor: 'ویرایش نویسنده',

  // Wiki Edit Descriptions
  updateWikiInformation: 'به‌روزرسانی اطلاعات و محتوای مقاله ویکی',
  updateCategoryInformation: 'به‌روزرسانی اطلاعات دسته‌بندی',
  updateAuthorInformation: 'به‌روزرسانی اطلاعات نویسنده',

  // Wiki Edit Fields
  wikiBasicDetails: 'جزئیات اصلی مقاله',
  selectCategory: 'انتخاب دسته‌بندی',
  selectAuthor: 'انتخاب نویسنده',
  wikiTitleDescription: 'عنوان مقاله به زبان‌های مختلف',
  wikiSummaryDescription: 'خلاصه مقاله برای نمایش در لیست‌ها',
  authorNameDescription: 'نام نویسنده به زبان‌های مختلف',
  authorBioDescription: 'زندگی‌نامه و سوابق نویسنده',
  categoryNameDescription: 'نام دسته‌بندی به زبان‌های مختلف',
  categoryDescriptionDescription: 'توضیحات دسته‌بندی',
  makeAuthorVisible: 'نویسنده را قابل مشاهده کنید',
  slugPreview: 'پیش‌نمایش نامک',
  supportedLanguages: 'زبان‌های پشتیبانی شده',
  quickSelectLanguage: 'یک زبان برای افزودن انتخاب کنید',
  allLanguagesAdded: 'تمام زبان‌های موجود اضافه شده‌اند',

  library: 'کتابخانه',
  magazines: 'مجلات',
  gallery: 'گالری و چندرسانه‌ای',
  astanStructures: 'ساختار آستان',
  newsSection: 'اخبار',
  wiki: 'ویکی و مقالات',
  heartTalk: 'حرف دل',
  contactUs: 'ارتباط با ما',
  
  // Chat
  chat: 'گفتگو',
  conversations: 'گفتگوها',
  organizations: 'سازمان‌ها',
  manageOrganizations: 'مدیریت موضوعات چت و Agent های مرتبط',
  noOrganizationsFound: 'سازمانی یافت نشد',
  organizationCreatedSuccessfully: 'سازمان با موفقیت ایجاد شد',
  organizationUpdatedSuccessfully: 'سازمان با موفقیت به‌روزرسانی شد',
  organizationDeletedSuccessfully: 'سازمان با موفقیت حذف شد',
  errorCreatingOrganization: 'خطا در ایجاد سازمان',
  errorUpdatingOrganization: 'خطا در به‌روزرسانی سازمان',
  errorDeletingOrganization: 'خطا در حذف سازمان',
  activeChats: 'گفتگوهای فعال',
  reconnecting: 'در حال اتصال مجدد...',
  connectionLost: 'ارتباط قطع شد. در حال تلاش برای اتصال مجدد.',
  connected: 'متصل شد',
  connectionRestored: 'ارتباط با موفقیت برقرار شد',
  guest: 'مهمان',
  noMessages: 'پیامی وجود ندارد',
  activeAs: 'فعال به عنوان {{name}}',
  impersonationActive: 'حالت نمایندگی فعال است',
  selectOrganization: 'برای شروع یک سازمان انتخاب کنید',
  addOrganization: 'افزودن سازمان',
  editOrganization: 'ویرایش سازمان',
  deleteOrganization: 'حذف سازمان',
  confirmDeleteOrganization: 'آیا مطمئن هستید که می‌خواهید این سازمان را حذف کنید؟',
  organizationName: 'نام سازمان',
  organizationDescription: 'توضیحات سازمان',
  searchPlaceholder: 'دستور یا جستجو را تایپ کنید...',
  noResults: 'نتیجه‌ای یافت نشد.',
  navigate: 'برای حرکت',
  closeKey: 'برای بستن',
  userManagement: 'مدیریت کاربران',
  portalSectionsMenu: 'بخش‌های پورتال',
  searchMessages: 'جستجوی پیام‌ها',
  dateFrom: 'از تاریخ',
  dateTo: 'تا تاریخ',
  messagePlaceholder: 'پیام خود را بنویسید...',
  noOrganizationSelected: 'هیچ سازمانی انتخاب نشده است',
  lastMessage: 'آخرین پیام',
  selectConversation: 'برای مشاهده جزئیات یک گفتگو را انتخاب کنید',
  contactInfo: 'اطلاعات تماس',
  location: 'موقعیت',
  personalInfo: 'اطلاعات شخصی',
  gender: 'جنسیت',
  male: 'مرد',
  female: 'زن',
  birthdate: 'تاریخ تولد',
  conversationId: 'شناسه گفتگو',
  totalMessages: 'کل پیام‌ها',
  accountActivity: 'فعالیت حساب کاربری',
  joinedAt: 'عضویت',
  lastLogin: 'آخرین ورود',
  clear: 'پاک کردن',
  filters: 'فیلترها',
  allOrganizations: 'همه سازمان‌ها',
  organizationDetails: 'جزئیات سازمان',
  userDetails: 'جزئیات کاربر',
  changesSaved: 'تغییرات ذخیره شد',
  deleted: 'با موفقیت حذف شد',
  name: 'نام',
  roomDetails: 'جزئیات اتاق',
  userInfo: 'اطلاعات کاربر',
  roomInfo: 'اطلاعات اتاق',
  ipAddress: 'آدرس IP',
  roomId: 'شناسه اتاق',

  // Dashboard
  overview: 'نمای کلی',
  today: 'امروز',
  thisWeek: 'این هفته',
  thisMonth: 'این ماه',
  thisYear: 'امسال',
  exportReport: 'خروجی گزارش',
  exporting: 'در حال خروجی...',
  reportExportedSuccessfully: 'گزارش با موفقیت دانلود شد',
  failedToExportReport: 'خطا در دانلود گزارش',
  totalVisits: 'کل بازدیدها',
  totalUsers: 'کل کاربران',
  activeUsers: 'کاربران فعال',
  newUsers: 'کاربران جدید',
  totalContent: 'کل محتوا',
  averageSessionTime: 'میانگین زمان جلسه',
  bounceRate: 'نرخ پرش',
  visitsOverTime: 'روند بازدیدها',
  detailed: 'جزئیات',
  topCountries: 'کشورهای برتر',
  topLanguages: 'زبان‌های برتر',
  visits: 'بازدید',
  mostViewedPages: 'صفحات پر بازدید',
  page: 'صفحه',
  views: 'نمایش‌ها',
  aiChatInteractions: 'تعاملات چت هوشمند',
  wikiArticles: 'مقالات ویکی',
  galleryItems: 'اقلام گالری',
  frequentlyAskedQuestions: 'سؤالات پرتکرار',
  question: 'سؤال',
  category: 'دسته‌بندی',
  frequency: 'تکرار',
  lastAsked: 'آخرین پرسش',
  
  // Profile
  profile: 'پروفایل',
  profileSettings: 'تنظیمات',
  updateYourPersonalInformation: 'به‌روزرسانی اطلاعات شخصی شما',
  profilePicture: 'تصویر پروفایل',
  uploadPhoto: 'آپلود عکس',
  allowedFormats: 'فرمت‌های مجاز',
  maxSize: 'حداکثر حجم',
  personalInformation: 'اطلاعات شخصی',
  locationInformation: 'اطلاعات مکانی',
  fullName: 'نام کامل',
  enterFullName: 'نام کامل خود را وارد کنید',
  enterEmail: 'ایمیل خود را وارد کنید',
  enterPhoneNumber: 'شماره تلفن خود را وارد کنید',
  selectGender: 'جنسیت را انتخاب کنید',
  selectLanguage: 'زبان را انتخاب کنید',
  enterCity: 'شهر خود را وارد کنید',
  enterCountry: 'کشور خود را وارد کنید',
  maleGender: 'مرد',
  femaleGender: 'زن',
  persianLang: 'فارسی',
  englishLang: 'انگلیسی',
  arabicLang: 'عربی',
  saveChanges: 'ذخیره تغییرات',
  profileUpdatedSuccessfully: 'پروفایل با موفقیت به‌روزرسانی شد',
  errorUpdatingProfile: 'خطا در به‌روزرسانی پروفایل',
  errorUploadingAvatar: 'خطا در آپلود تصویر پروفایل',
  fullnameRequired: 'نام کامل الزامی است',
  emailRequired: 'ایمیل الزامی است',
  emailAlreadyExists: 'این ایمیل قبلاً وجود دارد',
  fullnameInvalid: 'نام کامل نامعتبر است',
  help: 'راهنما',
  
  // Language
  language: 'زبان',
  english: 'انگلیسی',
  persian: 'فارسی',
  arabic: 'عربی',
  
  // Library - Books
  books: 'کتاب‌ها',
  book: 'کتاب',
  addBook: 'افزودن کتاب',
  addNewBook: 'افزودن کتاب جدید',
  editBook: 'ویرایش کتاب',
  updateBookInformation: 'به‌روزرسانی اطلاعات و ترجمه‌های کتاب',
  bookNotFound: 'کتاب یافت نشد',
  bookLoadError: 'خطا در بارگذاری اطلاعات کتاب',
  backToBooks: 'بازگشت به کتاب‌ها',
  booksTable: 'جدول کتاب‌ها',
  noBooksFound: 'کتابی یافت نشد',
  loading: 'در حال بارگذاری...',

  // Library Sub-modules (using existing translations)
  // authors: 'نویسندگان', (already defined in Book Fields)
  // publishers: 'ناشران', (already defined in Book Fields)
  // categories: 'دسته‌بندی‌ها', (already defined in Book Fields)
  // bookFiles: 'فایل‌های کتاب', (already defined in Book Files)

  // Library Common
  totalItems: 'مجموع {{count}} مورد',
  recentActivity: 'فعالیت‌های اخیر',
  newBookAdded: 'کتاب جدید اضافه شد',
  bookUpdated: 'کتاب به‌روزرسانی شد',
  newFileAdded: 'فایل جدید اضافه شد',
  hoursAgo: 'ساعت پیش',
  dayAgo: 'روز پیش',
  
  // Book Fields
  bookTitle: 'عنوان',
  bookSlug: 'نامک',
  isbn: 'شابک',
  rating: 'امتیاز',
  bookDescription: 'توضیحات',
  bookSummary: 'خلاصه',
  bookPublisher: 'ناشر',
  bookPublishDate: 'تاریخ انتشار',
  bookAuthors: 'نویسندگان',
  selectAuthors: 'انتخاب نویسندگان',
  bookCategories: 'دسته‌بندی‌ها',
  selectCategories: 'انتخاب دسته‌بندی‌ها',
  searchCategories: 'جستجوی دسته‌بندی‌ها...',
  loadingCategories: 'در حال بارگذاری دسته‌بندی‌ها...',
  loadingMore: 'بارگذاری بیشتر...',
  tryDifferentSearch: 'عبارت جستجوی دیگری را امتحان کنید',
  tryDifferentKeywords: 'کلمات کلیدی دیگری را امتحان کنید',
  clearSelection: 'پاک کردن انتخاب',
  errorLoadingCategories: 'خطا در بارگذاری دسته‌بندی‌ها',
  noCategoriesAvailable: 'دسته‌بندی موجود نیست',
  noResultsFound: 'نتیجه‌ای یافت نشد',
  of: 'از',
  addMoreCategories: 'افزودن دسته‌بندی‌های بیشتر',
  category: 'دسته‌بندی',
  pleaseEnterTitle: 'لطفاً عنوان را وارد کنید',
  pleaseSelectCategory: 'لطفاً حداقل یک دسته‌بندی انتخاب کنید',
  creatingPrayer: 'در حال ایجاد دعا...',
  updatingPrayer: 'در حال بروزرسانی دعا...',
  prayerCreatedSuccessfully: 'دعا با موفقیت ایجاد شد',
  prayerUpdatedSuccessfully: 'دعا با موفقیت بروزرسانی شد',
  errorCreatingPrayer: 'خطا در ایجاد دعا',
  errorUpdatingPrayer: 'خطا در بروزرسانی دعا',
  reciter: 'قاری',
  selectReciter: 'انتخاب قاری',
  uploadAudio: 'آپلود صوت',
  changeAudio: 'تغییر صوت',
  uploading: 'در حال آپلود...',
  audioUploadedSuccessfully: 'صوت با موفقیت آپلود شد',
  errorUploadingAudio: 'خطا در آپلود صوت',
  noAudioFiles: 'فایل صوتی موجود نیست',
  addAudio: 'افزودن صوت',
  audioFiles: 'فایل‌های صوتی',
  managePrayerAudioFiles: 'مدیریت فایل‌های صوتی دعا',
  searchReciters: 'جستجوی قاری‌ها...',
  noRecitersFound: 'قاری‌ای یافت نشد',
  noRecitersAvailable: 'قاری موجود نیست',
  loadMore: 'بارگذاری بیشتر',
  searchParts: 'جستجوی پارت‌ها...',
  remaining: 'باقی‌مانده',
  more: 'مورد دیگر',
  selectLanguages: 'انتخاب زبان‌ها',
  status: 'وضعیت',
  entryIsActive: 'این مورد فعال است',
  entryIsInactive: 'این مورد غیرفعال است',
  order: 'ترتیب',
  enterOrder: 'ترتیب نمایش را وارد کنید',
  orderDescription: 'ترتیب نمایش برای مرتب‌سازی',
  published: 'منتشر شده',
  draft: 'پیش‌نویس',
  viewCount: 'تعداد بازدید',
  createdAt: 'تاریخ ایجاد',
  updatedAt: 'تاریخ به‌روزرسانی',
  bookCover: 'جلد کتاب',
  displayOrder: 'ترتیب نمایش',
  
  // Translations
  bookTranslations: 'ترجمه‌ها',
  multilingualContent: 'محتوای چندزبانه و ترجمه‌ها',
  bookSupportedLanguages: 'زبان‌های پشتیبانی شده',
  bookAddLanguage: 'افزودن زبان',
  bookQuickSelectLanguage: 'یک زبان برای افزودن انتخاب کنید',
  bookAllLanguagesAdded: 'تمام زبان‌های موجود اضافه شده‌اند',
  titleTranslations: 'ترجمه‌های عنوان',
  bookDescriptionTranslations: 'ترجمه‌های توضیحات',
  summaryTranslations: 'ترجمه‌های خلاصه',
  close: 'بستن',
  
  // Sections
  bookBasicDetails: 'عنوان، شابک و جزئیات اصلی',
  contentDescriptions: 'محتوا و توضیحات',
  bookContentDetails: 'خلاصه و توضیحات تفصیلی',
  authorsPublisher: 'نویسندگان و ناشر',
  selectAuthorsAndPublisher: 'انتخاب نویسندگان و ناشر کتاب',
  bookCategoriesSection: 'دسته‌بندی‌ها و طبقه‌بندی کتاب',
  productDetails: 'جزئیات محصول',
  additionalProductInformation: 'مشخصات اضافی محصول',
  metadata: 'متادیتا',
  
  // Placeholders & Descriptions
  enterBookTitle: 'عنوان کتاب را وارد کنید',
  autoGeneratedFromTitle: 'به صورت خودکار از عنوان ایجاد می‌شود',
  bookSlugDescription: 'شناسه‌ی URL-friendly برای کتاب',
  briefSummary: 'خلاصه‌ای کوتاه از کتاب',
  bookSummaryDescription: 'خلاصه‌ای که در لیست‌ها نمایش داده می‌شود',
  detailedDescription: 'توضیحات تفصیلی کتاب',
  bookDescriptionDescription: 'توضیحات کامل که در صفحه کتاب نمایش داده می‌شود',
  selectPublisher: 'یک ناشر انتخاب کنید',
  bookOrderDescription: 'اعداد کوچکتر ابتدا نمایش داده می‌شوند',
  makeBookVisible: 'این کتاب را برای کاربران قابل مشاهده کنید',
  
  // Product Details
  detailTitle: 'عنوان جزئیات',
  detailValue: 'مقدار جزئیات',
  addDetail: 'افزودن جزئیات',
  
  // Book Files
  bookFiles: 'فایل‌های کتاب',
  uploadAndManageBookFiles: 'بارگذاری و مدیریت فایل‌های کتاب در فرمت‌های مختلف',
  noFilesAdded: 'هنوز فایلی اضافه نشده است',
  addFirstFile: 'افزودن اولین فایل',
  file: 'فایل',
  primary: 'اصلی',
  fileUploaded: 'فایل بارگذاری شد',
  uploadFile: 'بارگذاری فایل',
  change: 'تغییر',
  versionNumber: 'شماره نسخه',
  versionType: 'نوع نسخه',
  original: 'اصلی',
  pageCount: 'تعداد صفحات',
  fileFormat: 'فرمت فایل',
  setPrimaryFile: 'تنظیم به عنوان فایل اصلی',
  addAnotherFile: 'افزودن فایل دیگر',
  generatingDescription: 'در حال تولید توضیحات بر اساس اطلاعات کتاب',
  noImageSelected: 'تصویری انتخاب نشده است',
  
  // Actions
  cancel: 'انصراف',
  saveChanges: 'ذخیره تغییرات',
  uploadImage: 'بارگذاری تصویر',
  changeImage: 'تغییر تصویر',
  
  // Common
  more: 'بیشتر',
  back: 'بازگشت',
  edit: 'ویرایش',
  
  // Users & Permissions
  addUser: 'افزودن کاربر',
  editUser: 'ویرایش کاربر',
  userDetails: 'جزئیات کاربر',
  userNotFound: 'کاربر یافت نشد',
  backToUsers: 'بازگشت به کاربران',
  username: 'نام کاربری',
  phoneNumber: 'شماره تلفن',
  city: 'شهر',
  country: 'کشور',
  role: 'نقش',
  admin: 'مدیر',
  editor: 'ویرایشگر',
  viewer: 'بازدیدکننده',
  active: 'فعال',
  inactive: 'غیرفعال',
  permissionGroups: 'گروه‌های دسترسی',
  individualPermissions: 'دسترسی‌های اختصاصی',
  noPermissionGroups: 'هیچ گروه دسترسی تخصیص داده نشده است',
  activityInformation: 'اطلاعات فعالیت',
  memberSince: 'عضویت از',
  managePermissions: 'مدیریت دسترسی‌ها',
  usersTable: 'جدول کاربران',
  noUsersFound: 'کاربری یافت نشد',
  activeUserDescription: 'کاربران فعال می‌توانند وارد سیستم شوند',
  addPermission: 'افزودن دسترسی',
  addPermissionGroup: 'افزودن گروه دسترسی',
  permissions: 'دسترسی‌ها',
  searchPermissions: 'جستجوی دسترسی‌ها...',
  searchPermissionGroups: 'جستجوی گروه‌های دسترسی...',
  permissionsTable: 'جدول دسترسی‌ها',
  permissionGroupsTable: 'جدول گروه‌های دسترسی',
  noPermissionsFound: 'دسترسی یافت نشد',
  noPermissionGroupsFound: 'گروه دسترسی یافت نشد',
  module: 'ماژول',
  type: 'نوع',
  view: 'مشاهده',
  add: 'افزودن',
  delete: 'حذف',
  selectedPermissions: 'دسترسی‌های انتخاب شده',
  clearAll: 'پاک کردن همه',
  noPermissionsSelected: 'هیچ دسترسی انتخاب نشده است',

  // Toast Messages
  toastMessages: {
    // Network & API Errors - Admin-friendly messages
    networkError: 'عدم دسترسی به سرور',
    networkErrorDetail: 'اتصال اینترنت خود را بررسی کنید. اگر مشکل ادامه دارد، با تیم فنی تماس بگیرید',
    
    serverError: 'خطای سرور',
    serverErrorDetail: 'سرور با مشکل مواجه شده است. تیم فنی مطلع شده‌اند',
    serverErrorDetailWithRetry: 'سرور موقتاً در دسترس نیست. لطفاً چند دقیقه صبر کنید و دوباره تلاش کنید',
    
    serverDown: 'سرور در دسترس نیست',
    serverDownDetail: 'سرور در حال حاضر پاسخگو نیست. لطفاً با تیم فنی تماس بگیرید یا چند دقیقه دیگر امتحان کنید',
    
    serverTimeout: 'زمان درخواست تمام شد',
    serverTimeoutDetail: 'سرور طولانی‌تر از حد معمول پاسخ می‌دهد. ممکن است سرور مشغول باشد',
    
    unauthorizedError: 'نیاز به ورود مجدد',
    unauthorizedErrorDetail: 'نشست شما منقضی شده است. لطفاً دوباره وارد شوید',
    
    forbiddenError: 'عدم دسترسی',
    forbiddenErrorDetail: 'شما دسترسی لازم برای این عملیات را ندارید. با مدیر سیستم تماس بگیرید',
    
    notFoundError: 'محتوا یافت نشد',
    notFoundErrorDetail: 'اطلاعات درخواستی موجود نیست یا حذف شده است',
    
    validationError: 'خطا در اطلاعات وارد شده',
    validationErrorDetail: 'برخی فیلدها نامعتبر هستند. لطفاً فرم را بررسی کنید',
    
    conflictError: 'تداخل در اطلاعات',
    conflictErrorDetail: 'این اطلاعات قبلاً ثبت شده است یا با اطلاعات موجود تداخل دارد',
    
    tooManyRequestsError: 'درخواست‌های زیاد',
    tooManyRequestsErrorDetail: 'تعداد درخواست‌های شما از حد مجاز بیشتر است. لطفاً کمی صبر کنید',
    
    badGatewayError: 'مشکل در ارتباط با سرور',
    badGatewayErrorDetail: 'سرور نتوانست با سرویس‌های پشتیبانی ارتباط برقرار کند',
    
    serviceUnavailableError: 'سرویس موقتاً غیرفعال',
    serviceUnavailableErrorDetail: 'سرویس در حال نگهداری است. لطفاً چند دقیقه دیگر امتحان کنید',
    
    unknownError: 'خطای غیرمنتظره',
    unknownErrorDetail: 'خطای ناشناخته‌ای رخ داده است. لطفاً با تیم فنی تماس بگیرید',
    
    // Books
    bookCreatedSuccess: 'کتاب با موفقیت ایجاد شد',
    bookCreatedError: 'خطا در ایجاد کتاب',
    bookUpdatedSuccess: 'کتاب با موفقیت به‌روزرسانی شد',
    bookUpdatedError: 'خطا در به‌روزرسانی کتاب',
    bookDeletedSuccess: 'کتاب با موفقیت حذف شد',
    bookDeletedError: 'خطا در حذف کتاب',
    
    // News
    newsCreatedSuccess: 'خبر با موفقیت ایجاد شد',
    newsCreatedError: 'خطا در ایجاد خبر',
    newsUpdatedSuccess: 'خبر با موفقیت به‌روزرسانی شد',
    newsUpdatedError: 'خطا در به‌روزرسانی خبر',
    newsDeletedSuccess: 'خبر با موفقیت حذف شد',
    newsDeletedError: 'خطا در حذف خبر',
    
    // Reciters
    reciterCreatedSuccess: 'قاری با موفقیت ایجاد شد',
    reciterCreatedError: 'خطا در ایجاد قاری',
    reciterUpdatedSuccess: 'قاری با موفقیت به‌روزرسانی شد',
    reciterUpdatedError: 'خطا در به‌روزرسانی قاری',
    reciterDeletedSuccess: 'قاری با موفقیت حذف شد',
    reciterDeletedError: 'خطا در حذف قاری',
    
    // Login & Auth
    loginSuccess: 'ورود با موفقیت انجام شد',
    loginError: 'خطا در ورود. لطفاً دوباره تلاش کنید.',
    captchaRequired: 'لطفاً تایید کپچا را تکمیل کنید',
    
    // Generic
    savedSuccess: 'تغییرات با موفقیت ذخیره شد',
    savedError: 'خطا در ذخیره تغییرات',
    deletedSuccess: 'با موفقیت حذف شد',
    deletedError: 'خطا در حذف',
    allPermissions: 'تمام دسترسی‌ها',
    youHaveFullAccess: 'شما به تمام امکانات دسترسی کامل دارید',
    
    // File Upload (toast messages)
    fileUploadSuccess: 'فایل با موفقیت آپلود شد',
    fileUploadError: 'خطا در آپلود فایل',
    uploading: 'در حال آپلود...',
    fileTooLarge: 'حجم فایل باید کمتر از {{max}} باشد',
    pleaseSelectImageFile: 'لطفاً یک فایل تصویری انتخاب کنید',
    fileUploadedSuccessfully: 'فایل با موفقیت آپلود شد',
    
    createdSuccess: 'با موفقیت ایجاد شد',
    createdError: 'خطا در ایجاد',
    updatedSuccess: 'با موفقیت به‌روزرسانی شد',
    updatedError: 'خطا در به‌روزرسانی',
  },

  // 404 Page
  pageNotFound: 'صفحه یافت نشد',
  pageNotFoundMessage: 'صفحه‌ای که به دنبال آن هستید وجود ندارد یا منتقل شده است.',
  backToDashboard: 'بازگشت به داشبورد',

  // Page Titles
  pageTitles: {
    dashboard: 'داشبورد',
    login: 'ورود',
    users: 'کاربران و دسترسی‌ها',
    createUser: 'ایجاد کاربر جدید',
    userDetail: 'جزئیات کاربر',
    editUser: 'ویرایش کاربر',
    userPermissions: 'دسترسی‌های کاربر',
    permissions: 'مدیریت دسترسی‌ها',
    createPermission: 'ایجاد دسترسی جدید',
    editPermission: 'ویرایش دسترسی',
    createPermissionGroup: 'ایجاد گروه دسترسی',
    editPermissionGroup: 'ویرایش گروه دسترسی',
    technicalSupport: 'پشتیبانی فنی',
    settings: 'تنظیمات',
    statistics: 'آمار و گزارشات',
    chatConversations: 'گفتگوها',
    chatOrganizations: 'سازمان‌های گفتگو',
    imamIntro: 'زندگینامه امام',
    hadiths: 'ساب دسته‌بندی‌های حدیث',
    hadithsList: 'لیست ساب دسته‌بندی‌های حدیث',
    createHadith: 'ایجاد ساب دسته‌بندی حدیث جدید',
    editHadith: 'ویرایش ساب دسته‌بندی حدیث',
    hadithsCategories: 'دسته‌بندی اصلی',
    hadithsNarrators: 'راویان احادیث',
    createHadithNarrator: 'ایجاد راوی حدیث',
    editHadithNarrator: 'ویرایش راوی حدیث',
    hadithNarratorDetails: 'جزئیات راوی حدیث',
    hadithsReferences: 'منابع احادیث',
    createHadithReference: 'ایجاد منبع حدیث',
    editHadithReference: 'ویرایش منبع حدیث',
    hadithReferenceDetails: 'جزئیات منبع حدیث',
    hadithsParts: 'احادیث',
    prayers: 'ادعیه و زیارات',
    prayersList: 'لیست ادعیه',
    createPrayer: 'ایجاد دعا',
    editPrayer: 'ویرایش دعا',
    prayersCategories: 'دسته‌بندی‌های ادعیه',
    createPrayerCategory: 'ایجاد دسته‌بندی دعا',
    editPrayerCategory: 'ویرایش دسته‌بندی دعا',
    prayersNarrators: 'قاریان ادعیه',
    createPrayerNarrator: 'ایجاد قاری',
    editPrayerNarrator: 'ویرایش قاری',
    prayersReferences: 'منابع ادعیه',
    createPrayerReference: 'ایجاد منبع دعا',
    editPrayerReference: 'ویرایش منبع دعا',
    prayersParts: 'قسمت‌های ادعیه',
    createPrayerPart: 'ایجاد قسمت دعا',
    editPrayerPart: 'ویرایش قسمت دعا',
    library: 'کتابخانه',
    books: 'کتاب‌ها',
    editBook: 'ویرایش کتاب',
    authors: 'نویسندگان',
    editAuthor: 'ویرایش نویسنده',
    publishers: 'ناشران',
    createPublisher: 'ایجاد ناشر',
    editPublisher: 'ویرایش ناشر',
    categories: 'دسته‌بندی‌های کتاب',
    createCategory: 'ایجاد دسته‌بندی',
    editCategory: 'ویرایش دسته‌بندی',
    bookFiles: 'فایل‌های کتاب',
    magazines: 'مجلات',
    magazinesList: 'لیست مجلات',
    createMagazine: 'ایجاد مجله',
    editMagazine: 'ویرایش مجله',
    gallery: 'گالری و چندرسانه‌ای',
    media: 'رسانه‌ها',
    createMedia: 'افزودن رسانه',
    editMedia: 'ویرایش رسانه',
    mediaCategories: 'دسته‌بندی‌های رسانه',
    createMediaCategory: 'ایجاد دسته‌بندی رسانه',
    editMediaCategory: 'ویرایش دسته‌بندی رسانه',
    news: 'اخبار',
    newsList: 'لیست اخبار',
    createNews: 'ایجاد خبر',
    editNews: 'ویرایش خبر',
    newsCategories: 'دسته‌بندی‌های اخبار',
    specialFiles: 'فایل‌های ویژه',
    specialFilesList: 'لیست فایل‌های ویژه',
    createSpecialFile: 'ایجاد فایل ویژه',
    editSpecialFile: 'ویرایش فایل ویژه',
    wiki: 'ویکی و مقالات',
    wikiList: 'لیست مقالات',
    createWiki: 'ایجاد مقاله',
    editWiki: 'ویرایش مقاله',
    wikiCategories: 'دسته‌بندی‌های ویکی',
    createWikiCategory: 'ایجاد دسته‌بندی ویکی',
    editWikiCategory: 'ویرایش دسته‌بندی ویکی',
    wikiAuthors: 'نویسندگان ویکی',
    createWikiAuthor: 'ایجاد نویسنده',
    editWikiAuthor: 'ویرایش نویسنده',
    wikiContents: 'محتوای ویکی',
    heartTalk: 'حرف دل',
    heartTalkList: 'لیست حرف دل',
    heartTalkCategories: 'دسته‌بندی‌های حرف دل',
    heartTalkAuthors: 'گویندگان حرف دل',
    createHeartTalkAuthor: 'ایجاد گوینده',
    editHeartTalkAuthor: 'ویرایش گوینده',
    contactUs: 'ارتباط با ما',
  },

  // Keep old keys for backward compatibility
  dashboard: 'داشبورد',
  login: 'ورود',
  users: 'کاربران و دسترسی‌ها',
  createUser: 'ایجاد کاربر جدید',
  userDetail: 'جزئیات کاربر',
  editUser: 'ویرایش کاربر',
  userPermissions: 'دسترسی‌های کاربر',
  permissions: 'مدیریت دسترسی‌ها',
  createPermission: 'ایجاد دسترسی جدید',
  editPermission: 'ویرایش دسترسی',
  createPermissionGroup: 'ایجاد گروه دسترسی',
  editPermissionGroup: 'ویرایش گروه دسترسی',
  technicalSupport: 'پشتیبانی فنی',
  settings: 'تنظیمات',
  statistics: 'آمار و گزارشات',
  chatConversations: 'گفتگوها',
  chatOrganizations: 'سازمان‌های گفتگو',
  imamIntro: 'زندگینامه امام',
  hadiths: 'ساب دسته‌بندی‌های حدیث',
  hadithsList: 'لیست ساب دسته‌بندی‌های حدیث',
  createHadith: 'ایجاد ساب دسته‌بندی حدیث جدید',
  editHadith: 'ویرایش ساب دسته‌بندی حدیث',
  addHadith: 'افزودن ساب دسته‌بندی حدیث',
  hadithsCategories: 'دسته‌بندی اصلی',
  hadithsNarrators: 'راویان احادیث',
  hadithsReferences: 'منابع احادیث',
  hadithsParts: 'احادیث',
  prayers: 'ادعیه و زیارات',
  prayersList: 'لیست ادعیه',
  createPrayer: 'ایجاد دعا',
  editPrayer: 'ویرایش دعا',
  prayersCategories: 'دسته‌بندی‌های ادعیه',
  createPrayerCategory: 'ایجاد دسته‌بندی دعا',
  editPrayerCategory: 'ویرایش دسته‌بندی دعا',
  prayersNarrators: 'قاریان ادعیه',
  createPrayerNarrator: 'ایجاد قاری',
  editPrayerNarrator: 'ویرایش قاری',
  prayersReferences: 'منابع ادعیه',
  createPrayerReference: 'ایجاد منبع دعا',
  editPrayerReference: 'ویرایش منبع دعا',
  prayersParts: 'قسمت‌های ادعیه',
  createPrayerPart: 'ایجاد قسمت دعا',
  editPrayerPart: 'ویرایش قسمت دعا',
  noCategory: 'بدون دسته‌بندی',
  categoryPath: 'مسیر دسته‌بندی',
  library: 'کتابخانه',
  books: 'کتاب‌ها',
  editBook: 'ویرایش کتاب',
  authors: 'نویسندگان',
  editAuthor: 'ویرایش نویسنده',
  publishers: 'ناشران',
  createPublisher: 'ایجاد ناشر',
  editPublisher: 'ویرایش ناشر',
  categories: 'دسته‌بندی‌های کتاب',
  createCategory: 'ایجاد دسته‌بندی',
  editCategory: 'ویرایش دسته‌بندی',
  categoryDetails: 'جزئیات دسته‌بندی',
  categoryNotFound: 'دسته‌بندی یافت نشد',
  backToCategories: 'بازگشت به دسته‌بندی‌ها',
  deleteCategoryConfirmation: 'آیا مطمئن هستید که می‌خواهید این دسته‌بندی را حذف کنید؟',
  categoryHasBooks: 'این دسته‌بندی دارای {{count}} کتاب است.',
  booksCount: 'تعداد کتاب‌ها',
  noCategoriesFound: 'دسته‌بندی یافت نشد',
  searchCategories: 'جستجوی دسته‌بندی‌ها',
  categoriesTable: 'جدول دسته‌بندی‌ها',
  categoryTitle: 'عنوان دسته‌بندی',
  categoryTitleDescription: 'عنوان دسته‌بندی به زبان‌های مختلف',
  updateCategoryInformation: 'به‌روزرسانی اطلاعات دسته‌بندی',
  makeCategoryVisible: 'دسته‌بندی را فعال کنید',
  bookFiles: 'فایل‌های کتاب',
  magazines: 'مجلات',
  magazinesList: 'لیست مجلات',
  createMagazine: 'ایجاد مجله',
  editMagazine: 'ویرایش مجله',
  gallery: 'گالری و چندرسانه‌ای',
  media: 'رسانه‌ها',
  createMedia: 'افزودن رسانه',
  editMedia: 'ویرایش رسانه',
  mediaCategories: 'دسته‌بندی‌های رسانه',
  createMediaCategory: 'ایجاد دسته‌بندی رسانه',
  editMediaCategory: 'ویرایش دسته‌بندی رسانه',
  news: 'اخبار',
  newsList: 'لیست اخبار',
  createNews: 'ایجاد خبر',
  editNews: 'ویرایش خبر',
  newsCategories: 'دسته‌بندی‌های اخبار',
  specialFiles: 'فایل‌های ویژه',
  specialFilesList: 'لیست فایل‌های ویژه',
  createSpecialFile: 'ایجاد فایل ویژه',
  editSpecialFile: 'ویرایش فایل ویژه',
  wiki: 'ویکی و مقالات',
  wikiList: 'لیست مقالات',
  createWiki: 'ایجاد مقاله',
  editWiki: 'ویرایش مقاله',
  wikiCategories: 'دسته‌بندی‌های ویکی',
  createWikiCategory: 'ایجاد دسته‌بندی ویکی',
  editWikiCategory: 'ویرایش دسته‌بندی ویکی',
  wikiAuthors: 'نویسندگان ویکی',
  createWikiAuthor: 'ایجاد نویسنده',
  editWikiAuthor: 'ویرایش نویسنده',
  wikiContents: 'محتوای ویکی',
  heartTalk: 'حرف دل',
  heartTalkList: 'لیست حرف دل',
  heartTalkCategories: 'دسته‌بندی‌های حرف دل',
  heartTalkAuthors: 'گویندگان حرف دل',
  createHeartTalkAuthor: 'ایجاد گوینده',
  editHeartTalkAuthor: 'ویرایش گوینده',
  contactUs: 'ارتباط با ما',

  // Biography/Imam Intro
  timeline: 'خط زمانی',
  dragToReorder: 'برای مرتب‌سازی بکشید',
  biographyImage: 'تصویر بیوگرافی',
  changeImage: 'تغییر تصویر',
  remove: 'حذف',
  dragDropOrClick: 'بکشید و رها کنید یا کلیک کنید',
  noImageAvailable: 'تصویری موجود نیست',
  supportedFormats: 'فرمت‌های پشتیبانی شده',
  clickImageToChange: 'برای تغییر روی تصویر کلیک کنید',
  uploadImage: 'آپلود تصویر',
  yearRequired: 'وارد کردن سال الزامی است',
  titleRequired: 'حداقل یک عنوان ترجمه شده الزامی است',
  descriptionRequired: 'حداقل یک توضیحات ترجمه شده الزامی است',
  imageRequired: 'تصویر بیوگرافی الزامی است',
  supportedLanguages: 'زبان‌های پشتیبانی شده',
  addLanguage: 'افزودن زبان',
  selectBiographyFromTimeline: 'یک مورد بیوگرافی از خط زمانی بالا انتخاب کنید',
  editBiography: 'ویرایش بیوگرافی',
  biographyDetails: 'جزئیات بیوگرافی',
  newBiography: 'بیوگرافی جدید',
  year: 'سال',
  enterYear: 'سال را وارد کنید (مثال: ۱۴۸)',
  yearDescription: 'سال رویداد در تقویم هجری قمری',
  title: 'عنوان',
  description: 'توضیحات',
  visibility: 'نمایش',
  visibilityDescription: 'نمایش این مورد به کاربران',
  isActive: 'فعال',
  created: 'ایجاد شده',
  updated: 'به‌روزرسانی شده',
  actions: 'اقدامات',
  manageBiographyEntries: 'مدیریت موارد بیوگرافی و خط زمانی',
  editMode: 'حالت ویرایش',
  addNew: 'افزودن جدید',
  save: 'ذخیره',
  deleteConfirmationMessage: 'آیا مطمئن هستید که می‌خواهید این مورد بیوگرافی را حذف کنید؟ این عمل قابل بازگشت نیست.',
  errorLoadingBiographies: 'خطا در بارگذاری بیوگرافی‌ها. لطفاً دوباره تلاش کنید.',
  enterTranslationIn: 'ترجمه را وارد کنید در',
  aiAnalyzing: 'در حال تحلیل هوش مصنوعی...',
  generatingTranslation: 'در حال تولید ترجمه',
  noTitle: 'بدون عنوان',
  
  // Hadiths Section (sidebar)
  hadisCategories: 'دسته‌بندی اصلی',
  narrators: 'راویان',
  references: 'منابع',
  hadisParts: 'احادیث',

  // Hadiths / Hadis Parts - selectors & combobox states
  selectHadith: 'انتخاب ساب دسته‌بندی حدیث',
  searchHadiths: 'جستجوی ساب دسته‌بندی‌های حدیث...',
  searchNarrators: 'جستجوی راویان...',
  searchReferences: 'جستجوی منابع...',
  noHadithSelected: 'ساب دسته‌بندی حدیثی انتخاب نشده است',
  noNarratorSelected: 'راوی انتخاب نشده است',
  narratorId: 'شناسه راوی',
  enterNarratorId: 'شناسه راوی را وارد کنید',
  pleaseEnterText: 'لطفاً متن را وارد کنید',
  pleaseSelectHadith: 'لطفاً یک ساب دسته‌بندی حدیث انتخاب کنید',
  hadisPartNotFound: 'حدیث یافت نشد.',
  hadisPart: 'حدیث',
  addHadisPart: 'افزودن حدیث',
  createHadisPart: 'ایجاد حدیث',
  editHadisPart: 'ویرایش حدیث',
  hadisPartDetails: 'جزئیات حدیث',
  createNewHadisPart: 'ایجاد حدیث جدید',
  viewHadisPartInformation: 'مشاهده اطلاعات حدیث',
  updateHadisPartInformation: 'به‌روزرسانی اطلاعات حدیث',
  hadisPartCreatedSuccessfully: 'حدیث با موفقیت ایجاد شد',
  hadisPartUpdatedSuccessfully: 'حدیث با موفقیت به‌روزرسانی شد',
  hadisPartDeletedSuccessfully: 'حدیث با موفقیت حذف شد',
  errorCreatingHadisPart: 'خطا در ایجاد حدیث',
  errorUpdatingHadisPart: 'خطا در به‌روزرسانی حدیث',
  errorDeletingHadisPart: 'خطا در حذف حدیث',
  hadisPartVisibility: 'قابلیت مشاهده حدیث',
  unnamed: 'بدون نام',
  searchPlaceholder: 'جستجو...',

  // Hadith narrators and references management
  addNarrator: 'افزودن راوی',
  editNarrator: 'ویرایش راوی',
  narratorDetails: 'جزئیات راوی',
  narratorName: 'نام پایه راوی',
  narratorNameTranslations: 'ترجمه‌های نام راوی',
  enterNarratorTranslation: 'نام ترجمه‌شده راوی را وارد کنید',
  createNewNarrator: 'ایجاد راوی جدید',
  updateNarratorInformation: 'به‌روزرسانی اطلاعات راوی',
  backToNarrators: 'بازگشت به راویان',
  baseName: 'نام پایه',
  narratorsTable: 'جدول راویان',
  noNarratorsFound: 'راوی‌ای یافت نشد',
  errorLoadingNarrators: 'خطا در بارگذاری راویان',
  errorLoadingNarrator: 'خطا در بارگذاری راوی',
  narratorNameRequired: 'نام پایه راوی الزامی است',
  narratorCreatedSuccessfully: 'راوی با موفقیت ایجاد شد',
  narratorUpdatedSuccessfully: 'راوی با موفقیت به‌روزرسانی شد',
  narratorDeletedSuccessfully: 'راوی با موفقیت حذف شد',
  errorCreatingNarrator: 'خطا در ایجاد راوی',
  errorUpdatingNarrator: 'خطا در به‌روزرسانی راوی',
  errorDeletingNarrator: 'خطا در حذف راوی',
  deleteNarratorConfirmation: 'آیا از حذف راوی «{{name}}» مطمئن هستید؟',
  editReference: 'ویرایش منبع',
  referenceDetails: 'جزئیات منبع',
  createNewReference: 'ایجاد منبع جدید',
  updateReferenceInformation: 'به‌روزرسانی اطلاعات منبع',
  backToReferences: 'بازگشت به منابع',
  baseTitle: 'عنوان پایه',
  referencesTable: 'جدول منابع',
  noReferencesFound: 'منبعی یافت نشد',
  errorLoadingReferences: 'خطا در بارگذاری منابع',
  errorLoadingReference: 'خطا در بارگذاری منبع',
  referenceTitleRequired: 'عنوان پایه منبع الزامی است',
  enterReferenceTranslation: 'عنوان ترجمه‌شده منبع را وارد کنید',
  enterReferenceDescription: 'توضیحات منبع را وارد کنید',
  referenceCreatedSuccessfully: 'منبع با موفقیت ایجاد شد',
  referenceUpdatedSuccessfully: 'منبع با موفقیت به‌روزرسانی شد',
  referenceDeletedSuccessfully: 'منبع با موفقیت حذف شد',
  errorCreatingReference: 'خطا در ایجاد منبع',
  errorUpdatingReference: 'خطا در به‌روزرسانی منبع',
  errorDeletingReference: 'خطا در حذف منبع',
  deleteReferenceConfirmation: 'آیا از حذف منبع «{{title}}» مطمئن هستید؟',
  pleaseAddAtLeastOneTranslation: 'حداقل یک ترجمه معتبر وارد کنید',
  totalCount: 'تعداد کل',
  changeSortOrder: 'تغییر جهت مرتب‌سازی',
  selectImage: 'انتخاب تصویر',
  removeImage: 'حذف تصویر',
  invalidImageFormat: 'فرمت تصویر معتبر نیست',
  thumbnailUploadHint: 'تصویر اختیاری با حداکثر حجم ۵ مگابایت',
  
  // Heart Talk Section (sidebar)
  heartTalks: 'دل‌نوشته‌ها',
  heartTalkSpeakers: 'سخنرانان',
};
